// extracted by mini-css-extract-plugin
module.exports = {"compact":"MessageSku_compact__H6IwE","regular":"MessageSku_regular__29OKq","show":"MessageSku_show__nuoU9"};